import type { Location } from 'react-router';

/**
 * The settings dialog opens over the page it was called from (the page
 * stays behind it); opened directly, the home page is behind it.
 */
export type SettingsSection = 'general' | 'account' | 'notifications' | 'memory' | 'subscription' | 'organization';

export interface BackgroundState {
  background?: Location;
}

export function settingsLink(section: string, location: Location): { to: string; state: BackgroundState } {
  const state = location.state as BackgroundState | null;
  // inside the dialog the page behind it stays the same
  return { to: `/settings/${section}`, state: { background: state?.background ?? location } };
}
